import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import { SvgIcon } from "@material-ui/core";
import "./Spinner.scss";

const renderLoader = (message, small) => (
  <div className="loaderSpinner">
    <div className="containerSpinner">
      <div className={small ? "clipSpinner-small" : "clipSpinner"}>
        <SvgIcon
          viewBox="0 0 1 1"
          classes={{
            root: small ? "spinnerCapture-small" : "spinnerCapture",
          }}
        >
          <path d="M0.221,0.646 A0.042,0.042,0,0,1,0.167,0.621 a0.042,0.042,0,0,1,0.025,-0.053 L0.954,0.291 A0.5,0.5,0,0,0,0.019,0.364 L0.576,0.162 a0.042,0.042,0,1,1,0.028,0.078 L0.002,0.459 a0.5,0.5,0,0,0,0.143,0.392 l0.603,-0.22 A0.042,0.042,0,1,1,0.776,0.71 L0.218,0.913 A0.5,0.5,0,0,0,0.982,0.369" />
        </SvgIcon>
      </div>

      <div className="containerSpinnerText">{message}</div>
    </div>
  </div>
);

const Spinner = ({ children, isLoading, message, small }) =>
  small ? (
    <div
      className={classnames(
        "loaderSpinner-container",
        isLoading && "visibleSpinner-small",
      )}
    >
      {isLoading ? renderLoader(message, small) : null}
      {children}
    </div>
  ) : (
    <div
      className={classnames(
        "loaderSpinner-container",
        isLoading && "visibleSpinner",
      )}
    >
      {isLoading ? renderLoader(message, small) : null}

      {children}
    </div>
  );

Spinner.propTypes = {
  children: propTypes.node.isRequired,
  isLoading: propTypes.bool.isRequired,
  message: propTypes.string,
  small: propTypes.bool,
};

Spinner.defaultProps = {
  message: "Merci de patienter...",
  small: false,
};

export default Spinner;
